import { render } from "./PaginationControls.vue?vue&type=template&id=68da288a"
import script from "./PaginationControls.vue?vue&type=script&lang=js"
export * from "./PaginationControls.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__